// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__Hi_oN","ldsRoller":"Loader_ldsRoller__1wcuC"};